import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@api/useAuth";
import Admin from "@pages/admin/Admin";
import Welcome from "./Welcome";
import { isClinicScopedUser, isOrganizerOrAdmin, isObserver, isVisitor } from "@utils";

export default function Report() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isClinicScopedUser(user)) {
      const userClinics = user?.clinic;
      if (userClinics && userClinics.length > 0) {
        navigate(`/report/${userClinics[0]}`, { replace: true });
      } else {
        // If no clinic assigned, show error or default clinic
        console.error("User has no clinic assigned");
      }
    }
  }, [user, navigate]);

  if (isOrganizerOrAdmin(user) || isObserver(user)) {
    return <Admin />;
  }

  if (isClinicScopedUser(user)) {
    return (
      <div style={{ padding: 24 }}>
        <p>Redirecting to your clinic...</p>
      </div>
    );
  }

  if (isVisitor(user)) {
    return <Welcome />;
  }

  // Other roles - No access
  return (
    <div style={{ padding: 24 }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}
